import * as React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

import { IconProps } from '../index'

const RewardsFrame = ({ size = 49, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 49 49"
    fill="none"
    {...props}
  >
    <Rect width={49} height={49} fill="#FAF5EC" rx={5} />
    <Path
      fill="#9A6EBF"
      d="m27.08 11.539 11.086 7.873a1.503 1.503 0 0 1-.99 2.725l-1.086-.087-.862 10.809a1.886 1.886 0 0 1-3.76-.3l.863-10.81-5.17-.412-.863 10.81a1.886 1.886 0 0 1-3.76-.301l.863-10.809-5.169-.412-.854 10.695c-.087 1.1-1.525 1.884-2.626 1.796-1.1-.087-1.456-1.014-1.368-2.115l.854-10.695-.852-.068a1.503 1.503 0 0 1-.545-2.847l12.196-6.015a2 2 0 0 1 2.042.163Z"
    />
    <Path
      fill="#9A6EBF"
      d="M10.786 33.923a2 2 0 0 1 2.152-1.834l22.8 1.82a2 2 0 0 1 1.835 2.152l-.252 3.158-26.787-2.138.252-3.158Z"
    />
    <Path
      fill="#fff"
      d="M9.5 20.151v-2.357l13.436-8.015 13.436 8.015v2.357H33.78v12.73h-3.771V20.15h-5.186v12.73H21.05V20.15h-5.186v12.73h-4.007V20.15H9.5Z"
    />
    <Path
      stroke="#000"
      d="M11.857 20.151H9.5v-2.357l13.436-8.015 13.436 8.015v2.357H33.78m-21.922 0h4.008m-4.008 0v12.73h4.008V20.15m0 0h5.185m0 0v12.73h3.772V20.15m-3.772 0h8.958m0 0v12.73h3.771V20.15m-3.771 0h3.771"
    />
    <Path
      fill="#fff"
      stroke="#000"
      d="M10 34a1.5 1.5 0 0 1 1.5-1.5h22.872a1.5 1.5 0 0 1 1.5 1.5v2.668H10V34Z"
    />
  </Svg>
)
export default RewardsFrame
